/// <reference path="../types/types.d.ts" />

import { Injectable } from "@angular/core";
import { CustomMessageComponent } from './custom-message.component';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { LoggerService } from "@app/logger/logger.service";
import { lastValueFrom } from "rxjs";

const log = new LoggerService('CUSTOM MESSAGE SERVICE');

@Injectable({ providedIn: "root" })
export class CustomMessageService {


  constructor(
    private messageBar: MatSnackBar,
  ) {}
  
  open(data: Components.CustomMessageComponent.CustomMessageData): Promise<boolean> {
    
    let config = new MatSnackBarConfig();
    config.panelClass = ['custom-message'];
    config.panelClass.push(data.type);

    if (data.duration) config.duration = data.duration;
    config.data = { ...data }

    this.messageBar.openFromComponent(CustomMessageComponent, config);

    return new Promise ((resolve)=>{

      this.messageBar._openedSnackBarRef.onAction().subscribe(()=> {
        resolve(true);
      });

      this.messageBar._openedSnackBarRef.afterDismissed().subscribe(()=>{
        resolve(false);
      });
    });
  }

  close(){
    this.messageBar._openedSnackBarRef.dismiss()
  }



}